import { format } from 'date-fns';
import {
  DATE_INPUT_FORMAT,
  DATETIME_INPUT_FORMAT,
} from '../../../../constants';

export const formatStaticDateTime = (value: string | null): string | null => {
  if (!value) return null;

  const date = new Date(value);
  if (isNaN(date.getTime())) return value;

  const formatString = value.includes('T')
    ? DATETIME_INPUT_FORMAT
    : DATE_INPUT_FORMAT;

  try {
    return format(date, formatString);
  } catch {
    return value;
  }
};
